import React, { useEffect, useRef } from "react";
import "./UnityPlayer.css";
const buildLoaderUrl = "/Build/build17.loader.js";

const UnityPlayer = ({ onUnityInstance }) => {
    const canvasRef = useRef(null);
    let unityInstance = null;
  
    useEffect(() => {
        const onSuccess = (instance) => {
            unityInstance = instance;
            if (onUnityInstance) {
                onUnityInstance(instance);
            }
        };
  
        const onError = (message) => {
            console.error(message);
        };
  
        fetch(buildLoaderUrl)
            .then((response) => response.text())
            .then((source) => {
            const script = document.createElement("script");
            script.textContent = source;
            document.body.appendChild(script);
            return window.createUnityInstance;
        }).then(
            (createUnityInstance) => createUnityInstance(canvasRef.current, {
            dataUrl: "/Build/build17.data",
            frameworkUrl: "/Build/build17.framework.js",
            codeUrl: "/Build/build17.wasm",
            streamingAssetsUrl: "/StreamingAssets",

            companyName: "DefaultCompany",
            productName: "My project",
            productVersion: "0.1",
            })
        ).then((instance) => onSuccess(instance))
            .catch((err) => onError(err));

        return () => {
            if (unityInstance) {
                unityInstance.Quit();
            }
        };
    }, []);
  
    return (
      <div className="unity-player">
        <canvas id="unity-canvas" ref={canvasRef} className="unity-canvas"></canvas>
      </div>
    );
  };
  
  export default UnityPlayer;
  